import { Children, cloneElement, ComponentProps, isValidElement, PropsWithChildren } from 'react';
import { css, ClassNames } from '@emotion/react';
import { RadioCardField } from '@frontend/design-system';
import { AvailabilityRuleFormRow } from './AvailabilityRuleFormRow';

type RadioCardFieldRowProps = ComponentProps<typeof RadioCardField>;

export const RadioCardFieldRow = ({ children, ...props }: PropsWithChildren<RadioCardFieldRowProps>) => {
  return (
    <AvailabilityRuleFormRow>
      <ClassNames>
        {({ css: cls, cx }) => (
          <RadioCardField {...props} css={styles.patientBookingRadioField}>
            {Children.toArray(children).map((child) =>
              isValidElement(child)
                ? cloneElement(child, {
                    ...child.props,
                    className: cx(
                      child.props.className,
                      cls([styles.patientBookingOption, !child.props.description && styles.onlyTitle])
                    ),
                  })
                : child
            )}
          </RadioCardField>
        )}
      </ClassNames>
    </AvailabilityRuleFormRow>
  );
};

const styles = {
  patientBookingRadioField: css`
    > div {
      flex-direction: column;
    }
  `,
  patientBookingOption: css`
    & > div:nth-of-type(2) > div > span:first-of-type {
      width: 100%;
    }
  `,
  onlyTitle: css`
    align-items: center;
  `,
};
